<aura-dialog-layout [title]="dialogTitle()" [hideActions]="true">
  <div dialog-content class="w-full max-w-2xl mx-auto py-2">
    @if (currentStep() === 'workflow') {
      <etxe-property-application-workflow-explanation
        [activeStep]="data.activeStep ?? 1"
        (acknowledged)="onAcknowledgeWorkflow()"
      />
    } @else {
      <div class="flex flex-col gap-4">
        <!-- Bouton retour au workflow -->
        <button
          type="button"
          (click)="onBackToWorkflow()"
          class="inline-flex items-center gap-1.5 text-xs font-semibold text-primary hover:underline self-start cursor-pointer transition-colors"
        >
          <mat-icon class="text-sm! w-4! h-4! !text-primary">arrow_back</mat-icon>
          <span>Revoir le déroulement de la sélection</span>
        </button>

        <etxe-property-application-form
          [dto]="data.initialDto"
          [propertyId]="data.property._id"
          [property]="data.property"
          [isFinalOfferAdjustment]="data.activeStep === 3"
          (submitForm)="onFormSubmit($event)"
          (cancelled)="onCancel()"
        />
      </div>
    }
  </div>
</aura-dialog-layout>
